import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveResourceGroup } from "@planzone/view-models";

import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectResourceGroupRemoval({ group, cancel }: Props) {
  const { t } = useTranslation();
  const { removeResourceGroup, isRequestPending } =
    useRemoveResourceGroup(group);

  return (
    <Modal
      header={t("removeResourceGroup.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>{t("removeResourceGroup.group")}</p>
          <p className={styles.name}>{`> ${group.name}`}</p>
          <p className={styles.text}>{t("removeResourceGroup.removal")}</p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeResourceGroup.cancel")}
          </Button>
          <Button
            type={"delete"}
            status={isRequestPending ? "pending" : "none"}
            press={() => removeResourceGroup(group)}
          >
            {t("removeResourceGroup.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { ProjectResourceGroupRemoval };
